export default __webpack_public_path__ + "static/media/wwf_mobile_small@2x.c2970300.jpg";